import Immobilie from "../immobilie.model";

export const searchImmobilieByTerm = (property: Immobilie, term: string) => {
    const lowerCaseSearchTerm = term.toLowerCase();
    return (
        (property.externeObjektNr ? property.externeObjektNr.toLowerCase().includes(lowerCaseSearchTerm) : false) ||
        (property.strasse ? property.strasse.toLowerCase().includes(lowerCaseSearchTerm) : false) ||
        (property.stadt ? property.stadt.toLowerCase().includes(lowerCaseSearchTerm) : false) ||
        (property.plz ? property.plz.toLowerCase().includes(lowerCaseSearchTerm) : false) ||
        (property.name ? property.name.toLowerCase().includes(lowerCaseSearchTerm) : false) ||
        (property.eigentuemer ? property.eigentuemer.toLowerCase().includes(lowerCaseSearchTerm) : false) ||
        (property.baujahr !== null && property.baujahr !== undefined ? property.baujahr.toString().toLowerCase().includes(lowerCaseSearchTerm) : false)
    );
};